import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Clients } from '../components/finance/Clients';
import { Suppliers } from '../components/finance/Suppliers';
import { ETAReceived } from '../components/finance/ETAReceived';

export const ClientsSuppliers = () => {
  const { t, language } = useLanguage();
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'clients';

  return (
    <div className="p-4 md:p-8" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <h1 className="text-2xl md:text-4xl font-bold tracking-tight mb-6" lang={language === 'ar' ? 'ar' : 'en'} data-testid="clients-suppliers-title">
        {t('clientsAndSuppliers')}
      </h1>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="mb-6" dir={language === 'ar' ? 'rtl' : 'ltr'}>
          <TabsTrigger value="clients" data-testid="tab-clients">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('clients')}</span>
          </TabsTrigger>
          <TabsTrigger value="suppliers" data-testid="tab-suppliers">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('suppliers')}</span>
          </TabsTrigger>
          <TabsTrigger value="eta-received" data-testid="tab-eta-received">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('etaReceived')}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="clients">
          <Clients />
        </TabsContent>
        <TabsContent value="suppliers">
          <Suppliers />
        </TabsContent>
        <TabsContent value="eta-received">
          <ETAReceived />
        </TabsContent>
      </Tabs>
    </div>
  );
};
